import React, { createContext, useEffect, useState } from 'react';

import {
  CHOICES_DROPDOWN_ACTIVE,
  STRATEGIC_INGREDIENT_DROPDOWN_ITEMS,
} from '../routes/admin/utils/DropdownItems';
import { getListViewState } from './utils';

export const IngredientContext = createContext({});

export const IngredientProvider = ({ children }) => {
  const listViewStates = getListViewState();

  // Applied filters
  // Status is a boolean
  const [selectedStatus, setSelectedStatus] = useState(CHOICES_DROPDOWN_ACTIVE()[0]);

  /**
   *  IsStrategic is an array, can be:
   *  - only strategic
   *  - only not strategic
   *  - both (which is the default)
   *  */
  const [selectedStrategicFilters, setSelectedStrategicFilters] = useState(
    STRATEGIC_INGREDIENT_DROPDOWN_ITEMS(),
  );

  const [customParams, setCustomParams] = useState({});

  const [advancedFilters, setAdvancedFilters] = useState(null);

  useEffect(() => {
    listViewStates.setCurrentPage(1);
  }, [customParams, advancedFilters]);

  return (
    <IngredientContext.Provider
      value={{
        ...listViewStates,
        selectedStatus,
        setSelectedStatus,
        selectedStrategicFilters,
        setSelectedStrategicFilters,
        customParams,
        setCustomParams,
        advancedFilters,
        setAdvancedFilters,
      }}
    >
      {children}
    </IngredientContext.Provider>
  );
};
